export default {
  state: "State",
  addState: "AddState",
  editState: "EditState",
};
